import get from 'lodash/get';
import { put, take, call, select, takeLatest } from 'redux-saga/effects';

import * as error from '../../ui/error';
import { loggedUserIdSelector } from '../../context/selectors';
import { selectProgressIsUrgentVisitFlow } from '../selectors';
import * as confirmVisitUrgent from '../requests/confirm-visit-urgent-req';
import { ERROR_CODES, APPOINTMENT_ERRORS } from '../../../constants/errors';
import * as appointmentDetails from '../../appointmnents/appointment-details-req';
import * as couponVerification from '../../healthboard/requests/coupon-verification-req';
import { APPOINTMENT_DETAILS_TYPES } from '../../healthboard/appointment-details';
import * as paymentVerification from '../../healthboard/requests/payment-verifications-req';
import { consts as APPOINTMENT_ACCOUNT_FORM_PAYMENT } from '../../appointmnents/requests/appointment-account-form-payment-req';
import {
  redirectToSummary,
  redirectToHealthBoard,
} from '../../../utils/appointments/redirect-utils';

const { APPOINTMENT_PRICING_SCHEDULE_NOT_FOUND } = ERROR_CODES;

function* handleSuccessConfirmUrgentVisit({ payload }) {
  yield put(appointmentDetails.actions.succeed(payload));
}

function* handleErrorConfirmUrgentVisit({ payload }) {
  const { code } = get(payload, 'error', {});

  if (code === APPOINTMENT_PRICING_SCHEDULE_NOT_FOUND) {
    const userId = yield select(loggedUserIdSelector);
    yield put(error.actions.update({ id: APPOINTMENT_ERRORS[code] }));
    yield call(redirectToHealthBoard, userId);
  }
}

function* handleSuccessPaymentUrgentVisit() {
  if (yield select(selectProgressIsUrgentVisitFlow)) {
    yield take(paymentVerification.consts.SUCCEED);
    yield call(redirectToSummary);
    yield put(couponVerification.actions.clear());
  }
}

function* handleSuccessAppointmentPaymentAccountForm() {
  yield put(couponVerification.actions.clear());

  if (yield select(selectProgressIsUrgentVisitFlow)) {
    yield call(redirectToSummary);
  }
}

export default function* confirmUrgentVisitSaga() {
  yield takeLatest(
    [confirmVisitUrgent.consts.SUCCEED],
    handleSuccessConfirmUrgentVisit,
  );
  yield takeLatest(
    [confirmVisitUrgent.consts.REJECTED],
    handleErrorConfirmUrgentVisit,
  );
  yield takeLatest(
    [APPOINTMENT_DETAILS_TYPES.PAYMENT_SUCCESS],
    handleSuccessPaymentUrgentVisit,
  );
  yield takeLatest(
    [APPOINTMENT_ACCOUNT_FORM_PAYMENT.SUCCEED],
    handleSuccessAppointmentPaymentAccountForm,
  );
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/sagas/confirm-visit-urgent-saga.js